import { Pipe, PipeTransform } from '@angular/core';
import { LowercaseTranslocoService } from '../../services/utils/TranslocoService';

@Pipe({
  name: 'lowercaseTransloco',
  standalone: true
})
//FIXME PERCHE?
export class LowercaseTranslocoPipe implements PipeTransform {
  constructor(private lowercaseTranslocoService: LowercaseTranslocoService) {}

  transform(key: string, params?: any): string {
    return this.lowercaseTranslocoService.translate(key, params);
  }
}
